import { render } from "./ProveedoresView.vue?vue&type=template&id=8f5cb318&scoped=true"
import script from "./ProveedoresView.vue?vue&type=script&lang=js"
export * from "./ProveedoresView.vue?vue&type=script&lang=js"

import "./ProveedoresView.vue?vue&type=style&index=0&id=8f5cb318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5cb318"]])

export default __exports__